import * as React from 'react';
import { ButtonBase } from '@mui/material'

export type Props = {
	category?:string
	selectedCategory?:string
	onClick?:Function
	onModuleCreatorOpenToggle?:Function
	children?: JSX.Element,
	iconName?: string,
	moduleCreatorOpened?: boolean
}

export default class ModuleAdd extends React.Component<Props> {

	private onClick = () => {
		if (this.props.selectedCategory && this.props.selectedCategory == this.props.category) {
			this.props.onModuleCreatorOpenToggle();
		} else {
			this.props.onClick();
		}
	}

	render() {
		let isActiveClass = (this.props.selectedCategory == this.props.category && this.props.moduleCreatorOpened) ? 'active' : '';
		return <ButtonBase style={ {borderRadius: '3px', marginTop: '5px'} } >
			<div onClick={this.onClick} className={isActiveClass + " action-buttons-icon"} >
				<img src={"static/img/icons/" + this.props.iconName + "-icon.svg"} alt="" width="36" height="36" />
				<div className="text">{this.props.children}</div>
			</div>
		</ButtonBase>
	}
}